import { handleApiResponse, notifyInternalMessage } from '@/functions';
import { IHooksUseRequestDeleteUserParams } from '@/interfaces';
import { useMutation } from '@tanstack/react-query';
import { useInvalidateQueries } from '@/hooks';
import { broadcastService } from '@/services';
import { apiClient } from '@/components/api';
import routes from '@/lib/routes';

type TParams = {
  disableInvalidateQueries?: boolean;
};
type TDataVariables = IHooksUseRequestDeleteUserParams;
type TResponseData = void;

export const useRequestDeleteUser = (params?: TParams) => {

  const { invalidate } = useInvalidateQueries();
  const { isPending, error, mutateAsync } = useMutation({
    mutationKey: [routes.api.users.base, 'delete'],
    mutationFn: (data: TDataVariables) =>
      apiClient
        .delete<TResponseData>(routes.api.users.delete, data)
        .then(handleApiResponse)
        .then(() => broadcastService.events.publish({ type: 'userDeleted', data }))
        .catch(notifyInternalMessage),
    onSuccess: () => (
      !params?.disableInvalidateQueries &&
      Promise
        .all([
          invalidate(routes.api.subAccounts),
          invalidate(routes.api.searchUser),
          invalidate(routes.api.users.base)
        ])
    )
  });

  const triggerDeleteUser = (data: TDataVariables) =>
    mutateAsync(data);

  return ({
    isLoadingDeleteUser: isPending,
    triggerDeleteUser,
    error
  });

};  
